import { JwtPayload } from 'jwt-decode';

import { url } from '@api-config';
import { app_json_content_type, getRefreshToken } from 'Api/utils/getAuthHeaders';
import handleResponseText from 'Api/utils/handleResponseText';
import parseResponse from 'Api/utils/parseResponse';
import { logout } from 'utils/Auth';
import { EOAuthLoginRequest } from 'utils/Auth/loginFlows';
import { ITokenResponse } from 'utils/Auth';

let isRefreshing = false;
let refreshTokenPromise: Promise<void> | null = null;

/**
 * Requests a refresh token for SSO authentication flow
 * @param usersOldToken - previous token info
 * @returns
 */
export const requestRefreshTokenSSO = async (
  usersOldToken: JwtPayload & { tenantUUID: string; exp?: number }
) => {
  if (isRefreshing) {
    return refreshTokenPromise;
  }

  isRefreshing = true;
  refreshTokenPromise = (async () => {
    try {
      // fetch refresh token & reset to new token
      const newTokensResponse = await fetch(url.refreshTokenSSO, {
        method: 'POST',
        headers: {
          'Content-Type': app_json_content_type,
        },
        body: JSON.stringify({
          refreshToken: getRefreshToken(),
        }),
      });
      const newTokensTextProcessed = await handleResponseText(newTokensResponse);
      const newTokens: ITokenResponse = parseResponse(newTokensTextProcessed);

      // request to login w/new token
      await EOAuthLoginRequest({
        oauthToken: newTokens?.oauthToken,
        refreshToken: newTokens?.refreshToken,
        userName: newTokens.user.userName || '',
        tenantId: usersOldToken?.tenantUUID,
        isDefaultTenantSelected: false,
        accessToken: newTokens?.accessToken,
      });
    } catch (err) {
      console.warn('There was an error getting the refresh tokens:', err);
      logout();
    } finally {
      isRefreshing = false;
      refreshTokenPromise = null;
    }
  })();

  return refreshTokenPromise;
};
